<template>
    <v-slide-y-transition mode="out-in">
        <v-layout row>
        <v-flex xs12 md6>
            <h1>Create Organization</h1>
            <v-form v-model="FormValid" v-on:submit.prevent="createOrganization" ref="form">
                <v-text-field name="input-Name" v-model="OrganizationName" :rules="organizationNameRules" label="Organization Name"></v-text-field>        
                <v-text-field name="input-SubDomain" v-model="SubDomain" label="SubDomain" :rules="subdomainRules" required></v-text-field>        
                <v-btn color="success" @click.prevent="createOrganization" :disabled="!FormValid">Create Organization</v-btn>
                <br><br>     
            </v-form>
        </v-flex>
        </v-layout>
    </v-slide-y-transition>
</template>
    

<script>
import axios from "axios";

export default {
  name: "RegisterOrganization",
  
  data() {
    return {
        OrganizationName: "",
        SubDomain: "",
        FormValid:true,
        organizationNameRules: [
            v => !!v || 'Organization Name is required',
            v => /^.{0,50}$/.test(v) || 'Maximum subdomain length is 50 characters',
        ],
        subdomainRules: [
            v => !!v || 'Subdomain is required',
            v => /^[A-Za-z0-9\-]+$/.test(v) || 'Subdomain contains invalid characters',
            v => /^[A-Za-z0-9\-]{0,24}$/.test(v) || 'Maximum subdomain length is 24 characters',
            v => /^[A-Za-z]/.test(v) || 'Subdomain must start with a letter',
            v => /[A-Za-z0-9]$/.test(v) || 'Subdomain must end with a letter or number',
        ],
    };
  },
  methods: {
    createOrganization: function() {
        if (this.$refs.form.validate()) {  //check is likely unnessary (redundant) as submit button is disabled until fields are valid
        console.info('createOrganization');

        const params = { name: this.OrganizationName, subdomain: this.SubDomain };
        axios.post(
                "/api/org/create",
                params,
                this.$store.state.axiosConfig
            )
            .then(response => {
                console.log("new organization created", response);
                // Display Success message
                this.$store.commit('replaceSnackbar', {
                    message:"New Organization Successfully Created.<br>Switched to use New Organization",
                });

                // Commit user info to global
                this.$store.commit('setUserSelf', response.data);

                // User profile may now be complete - dispatch for potential update to global flag 
                this.$store.commit('refreshUserProfileIsComplete');

            })
            .catch(e => {
                // check/ handle 401 (Unauthorized) error
                this.$store.dispatch('error401Response', e);

                // Display Error message
                this.$store.commit('replaceSnackbar', {
                    message:"Error.  Organization was NOT created.<br>Response: " + e.response.data.message + "<br>Error #KDN849",
                    messageType:"error",
                });

                console.log(e);
                console.log(e.response);
            });

        }
    },
  },
  computed: {
  }

};
</script>
